<ng-container *transloco="let t">
  @if(inputForm && itemsKey){
    <div class="pt-2">
      <div class="field-title pt-4">
        <div class="d-flex justify-content-between">
          <span class="fw-semibold">{{ label }}
          </span>
          <button type="button" class="round-button red" (click)="deleteItems()">
            <i class="bi bi-trash-fill"></i>
          </button>
        </div>
      </div>
      <form [formGroup]="inputForm">
        @if(items.controls.length > 0){
          <ng-container [formArrayName]="itemsKey">
            @if(hasError){
              <p class="pt-4">
                <ngb-alert [dismissible]="false" class="warning-info">
                  {{ t("administrator.categories.items.error") }}
                </ngb-alert>
              </p>
            }
            <div class="row pt-3">
              @for (item of items.controls; track item; let idx=$index) {
              <ng-container>
                <ng-container [formGroupName]="idx">
                  <div class="col-6 col-xl-2 mb-3">
                    <app-input formControlName="ageFrom" label="administrator.categories.item.age.from"/>
                  </div>
                  <div class="col-6 col-xl-2 mb-3">
                    <app-input formControlName="ageTo" label="administrator.categories.item.age.to" [max]="110"/>
                  </div>
                  <div class="col-12 col-xl-3 mb-3">
                    <app-input formControlName="name" label="administrator.categories.item.name"/>
                  </div>
                  <div class="col-12 col-xl-3 mb-3">
                    <app-input formControlName="code" label="administrator.categories.item.code"/>
                  </div>
                  <div class="col-6 col-xl-1">
                    <div class="form-floating mb-3 mt-36">
                      <div class="form-check form-switch mb-3 d-flex align-items-center">
                        <input class="form-check-input me-3" type="checkbox" id="active{{idx}}" formControlName="active"
                          placeholder='{{t("")}}'>
                        <label class="form-check-label">{{ t("administrator.categories.item.active") }}</label>
                      </div>
                    </div>
                  </div>
                  @if(items.length > 1){
                  <div class="col-6 col-xl-1">
                    <div class="d-flex justify-content-end mt-30">
                      <button type="button" class="round-button" (click)="deleteItem(idx)">
                        <i class="bi bi-trash-fill"></i>
                      </button>
                    </div>
                  </div>
                  }
                </ng-container>
              </ng-container>
              }
            </div>
          </ng-container>
        }

        <div class="pe-3 pt-2">
          <app-rounded-button [label]="t('administrator.categories.item.add')" (onClick)="addItem()"><i
            class="bi bi-plus-circle pe-2"></i></app-rounded-button>
        </div>
      </form>
    </div>
  }

  </ng-container>
